import geometry from '../../../scene/util/geometry';
import idGenerator from '../../../util/aactools/idGenerator';
import makeSpaceForChild from './makeSpaceForChild';
import _ from 'lodash';

import sorter from './sorter';
import { replace } from '../replace';
import connectParts from './connectParts';
import { getBoundedItem } from '../../../services/products/models';
import tacHelpers from '../tacHelpers';

// ITEMS
export default function addItem(model, item, parent = model, options = {}) {
  if (idGenerator.hasRealId(item)) {
    throw new Error(
      'You are trying to add an already existing item to the TAC!'
    );
  }

  const collidingItems = parent.items
    ? geometry.getCollidingRects(
        getBoundedItem(item, 'collision'),
        parent.items
          .map(sibling => getBoundedItem(sibling, 'collision'))
          .filter(
            sibling =>
              !tacHelpers.shouldIgnoreCollision(item, parent, sibling) &&
              geometry.contains(parent, sibling)
          )
      )
    : [];

  if (collidingItems.length > 0) {
    return false;
  }

  item.itemid = options.isPersistent ? idGenerator.id() : idGenerator.fakeId();

  if (!item.items) {
    item.items = [];
  }

  let newParent = {
    ...parent,
    items: parent.items
      ? sorter.inDrawOrder(parent.items.concat(item))
      : [item],
  };

  if (item.parts) {
    const newItem = newParent.items.find(
      parentItem => parentItem.itemid === item.itemid
    );
    newParent = connectParts(newItem, newParent, parent, model, options);
  }
  makeSpaceForChild(item, newParent, model);
  if (parent === model) {
    return newParent;
  } else {
    const out = _.cloneDeep(model);
    replace(out.items, newParent);
    return out;
  }
}
